export const selectedScenarioBgColor = " #EDF2FA"
export const tableDeployedBgColor = " #27AE60"
export const tableUndeployedBgColor = " #C0392B"

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];


